export const generalIssueGroupId = 'GENERAL';
export const generalIssueGroupName = 'GENERAL';
export const issueFragmentSeparator = '-'; // separates parts of fragment (anchor for issue group)
export const deploymentHostTargetName = 'deploymentHosts';
